import { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import kolkataImg from "@assets/Kolkata_1771749413973.png";

export function PWALoader({
  message = "Loading DailyHisaab...",
}: {
  message?: string;
}) {
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMinTimeElapsed(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFBF2] dark:bg-[#1A1614] flex flex-col items-center justify-between py-12">
      <div className="flex-1" />

      <div className="flex flex-col items-center gap-6">
        <div className="flex items-center gap-3">
          <div className="bg-[#8B0000] rounded-xl p-2.5 flex items-center justify-center">
            <BookOpen className="h-8 w-8 text-white" strokeWidth={2.5} />
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-light tracking-tight text-gray-500 dark:text-gray-400">
              Daily
            </span>
            <span className="text-3xl font-bold tracking-tight text-[#8B0000]">
              Hisaab
            </span>
          </div>
        </div>

        <div className="w-48 h-1 bg-gray-200 dark:bg-zinc-800 rounded-full overflow-hidden">
          <div
            className="h-full bg-[#8B0000] rounded-full"
            style={{
              animation: "progressSlide 1.5s ease-in-out infinite",
            }}
          />
        </div>

        <p className="text-gray-500 dark:text-gray-400 text-sm font-medium">
          {message}
        </p>
      </div>

      <div className="flex-1" />

      <img src={kolkataImg} alt="Kolkata skyline" className="w-full mb-2" />
      <p className="text-gray-400 dark:text-gray-600 text-xs tracking-[0.2em] uppercase font-medium">
        Made with love ❤️ in Bengal
      </p>

      <style>{`
        @keyframes progressSlide {
          0% { width: 0%; margin-left: 0%; }
          50% { width: 60%; margin-left: 20%; }
          100% { width: 0%; margin-left: 100%; }
        }
      `}</style>
    </div>
  );
}
